import type { MeasurementGroupDisplay } from '../../types/reportDetail';
import { MeasurementCard } from './MeasurementCard';
import styles from './MeasurementsSection.module.css';

interface MeasurementsSectionProps {
  groups: MeasurementGroupDisplay[];
}

export default function MeasurementsSection({
  groups,
}: MeasurementsSectionProps) {
  // Only legend what is actually on the page — the same condition the PDF uses.
  const hasAIValue = groups.some((g) => g.items.some((i) => i.isAIValue));

  return (
    <section className={styles.section}>
      <h3 className={styles.sectionTitle}>Measurements</h3>
      {hasAIValue && (
        <p className={styles.legend}>
          <span className={styles.legendMark} aria-hidden="true">
            ✦
          </span>{' '}
          AI-derived value — not reviewed by a reader
        </p>
      )}
      {groups.length === 0 ? (
        <p className={styles.empty}>No measurements recorded.</p>
      ) : (
        <div className={styles.grid}>
          {groups.map((g) => (
            <MeasurementCard key={g.groupLabel} group={g} />
          ))}
        </div>
      )}
    </section>
  );
}
